import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { GlobalService } from '../global/global.service';

export interface IBalance {
  codigoMoneda?: string;
  nombreMoneda?: string;
  montoTotTexto?: string;
  montoTotal?: number;
  fondInv?: [];
  fondMut?: [];
  fondos?: [
    {
      nombreFondo: string;
      numCuotas: number;
      numCuotasTexto: string;
      valorCuota: number;
      valorCuotaTexto: string;
      saldo: number;
      saldoTexto: string;
      fecha: string;
      porcenFondo: number;
      clasefondo: string;
    }
  ];
}

@Injectable({
  providedIn: 'root',
})
export class DashboardRequestsService {
  PENColors = ['#AB9768', '#DBD1BB', '#5C4F43', '#8E7B69', '#6A798B'];
  USDColors = ['#225D99', '#7BAEE2', '#185760', '#2CA1B2', '#18416B'];
  AssetsColor = ['#225D99', '#7BAEE2', '#7B8C9C', '#5C4F43', '#98DEE7', '#BECAD3', '#2CA1B2'];
  //
  constructor(private http: HttpClient, private globalService: GlobalService, private router: Router) { }

  getBalance(CUC, Currency) {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/dashboard/private/listarSaldoMoneda/${CUC}/${Currency}`)
      .pipe(map((apiResponse) => this.mapBalance(apiResponse, Currency)));
  }

  getDistribution(CUC) {
    return this.http
      .get(`${this.globalService.globalEnvironments.apiEndpoint.apiFondos}/dashboard/private/listarDistribucionAssetClass/${CUC}`)
      .pipe(map((apiResponse) => this.mapDistribution(apiResponse)));
  }

  mapDistribution(apiResponse: { datos: { listaAssetClass: [] } } | any) {
    if (apiResponse.datos.listaAssetClass) {
      apiResponse.datos.listaAssetClass = apiResponse.datos.listaAssetClass.filter((f) => f.porcenAssetClass > 0);
      apiResponse.datos.listaAssetClass.forEach((f, key) => {
        f.color = this.AssetsColor[key];
      });
    } else apiResponse.datos.listaAssetClass = [];

    return apiResponse;
  }

  mapBalance(apiResponse: { datos: { fondos: [] } } | any, Currency) {
    apiResponse.datos.fondos = apiResponse.datos.fondos.filter((f) => f.saldo > 0);

    if (Currency === 'SOL') {
      apiResponse.datos.fondos.forEach((f, key) => (f.color = this.PENColors[key] ? this.PENColors[key] : '#BECAD3'));
    }

    if (Currency === 'DOL') {
      apiResponse.datos.fondos.forEach((f, key) => (f.color = this.USDColors[key] ? this.USDColors[key] : '#BECAD3'));
    }
    //
    apiResponse.datos['fondInv'] = apiResponse.datos.fondos.filter((f: any) => f.clasefondo === 'INV');
    apiResponse.datos['fondMut'] = apiResponse.datos.fondos.filter((f: any) => f.clasefondo === 'MUT');

    return apiResponse.datos;
  }
}
